var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 280,
    viewBox: "0 0 215 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.324 93.6098C214.324 196.158 149.627 279.065 70.063 279.065C-9.50099 279.065 -74.1982 196.158 -74.1982 93.6098C-74.1982 -8.93821 -9.50099 -91.8457 70.063 -91.8457C149.627 -91.8457 214.324 -8.93821 214.324 93.6098Z",
    stroke: "#210D15",
    strokeOpacity: 0.74
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186.176 65.2001C186.176 167.748 121.478 250.656 41.9145 250.656C-37.6494 250.656 -102.347 167.748 -102.347 65.2001C-102.347 -37.3479 -37.6494 -120.255 41.9145 -120.255C121.478 -120.255 186.176 -37.3479 186.176 65.2001Z",
    stroke: "#210D15",
    strokeOpacity: 0.74
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.022 41.9555C157.022 144.504 92.3251 227.411 12.7612 227.411C-66.8027 227.411 -131.5 144.504 -131.5 41.9555C-131.5 -60.5925 -66.8027 -143.5 12.7612 -143.5C92.3251 -143.5 157.022 -60.5925 157.022 41.9555Z",
    stroke: "#210D15",
    strokeOpacity: 0.74
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLine);
export default __webpack_public_path__ + "static/media/bg-line.f39c4b465c8a6e3ff3d861e7aa8da2b8.svg";
export { ForwardRef as ReactComponent };